export const contactInfo = {
  phone: "+91 9380130076",
  email: "uandiunisexsalon@gmail.com",
  address: "10th Cross, KHB Colony Surya Putra Circle Road",
  city: "Chitradurga, 577501",
  mapsUrl: "https://maps.app.goo.gl/WqL4HAUJfkpnEcMz7",
  hours: {
    monday: "08:30 AM - 08:30 PM",
    tuesday: "09:00 AM - 07:00 PM",
    wednesday: "08:30 AM - 08:30 PM",
    thursday: "08:30 AM - 08:30 PM",
    friday: "08:30 AM - 08:30 PM",
    saturday: "08:30 AM - 09:30 PM",
    sunday: "08:30 AM - 09:30 PM"
  }
};